import React from "react";
import { Typography } from "antd";
import { formatMoney } from "../../../../utils/util";

// เกณฑ์สีของจำนวนคงเหลือ ปรับตัวเลขได้ตามความเหมาะสมของแต่ละหน่วยสินค้า
const LOW_QTY_THRESHOLD = 10;
const MEDIUM_QTY_THRESHOLD = 100;

const remainingTextType = (v) => {
  const num = Number(v || 0);
  if (num < LOW_QTY_THRESHOLD) return "danger";
  if (num < MEDIUM_QTY_THRESHOLD) return "warning";
  return "success";
};

const RemainingValue = ({ value }) => (
  <Typography.Text type={remainingTextType(value)} strong>
    {formatMoney(value, 2)}
  </Typography.Text>
);

const ShortageValue = ({ value }) => (
  <Typography.Text type="danger" strong>
    {formatMoney(value, 2)}
  </Typography.Text>
);

export const minStockAlertColumns = () => [
  {
    title: "รหัสสินค้า",
    dataIndex: "stcode",
    key: "stcode",
    width: 160,
    sorter: (a, b) => (a.stcode || "").localeCompare(b.stcode || ""),
  },
  {
    title: "ชื่อสินค้า",
    dataIndex: "stname",
    key: "stname",
    sorter: (a, b) => (a.stname || "").localeCompare(b.stname || ""),
  },
  {
    title: "คงเหลือ",
    dataIndex: "remaining",
    key: "remaining",
    align: "right",
    width: 130,
    sorter: (a, b) => Number(a.remaining || 0) - Number(b.remaining || 0),
    render: (v) => <RemainingValue value={v} />,
  },
  {
    title: "สต๊อกขั้นต่ำ",
    dataIndex: "min_stock",
    key: "min_stock",
    align: "right",
    width: 130,
    sorter: (a, b) => Number(a.min_stock || 0) - Number(b.min_stock || 0),
    render: (v) => formatMoney(v, 2),
  },
  {
    title: "ขาดอีก",
    dataIndex: "shortage",
    key: "shortage",
    align: "right",
    width: 130,
    sorter: (a, b) => Number(a.shortage || 0) - Number(b.shortage || 0),
    render: (v) => <ShortageValue value={v} />,
  },
  {
    title: "หน่วย",
    dataIndex: "unit",
    key: "unit",
    align: "center",
    width: 100,
    render: (v) =>
      v ? v : <Typography.Text type="secondary">-</Typography.Text>,
  },
];

export const netRequiredColumns = () => [
  {
    title: "รหัสสินค้า",
    dataIndex: "stcode",
    key: "stcode",
    width: 160,
    sorter: (a, b) => (a.stcode || "").localeCompare(b.stcode || ""),
  },
  {
    title: "ชื่อสินค้า",
    dataIndex: "stname",
    key: "stname",
    sorter: (a, b) => (a.stname || "").localeCompare(b.stname || ""),
  },
  {
    title: "คงเหลือ",
    dataIndex: "remaining",
    key: "remaining",
    align: "right",
    width: 120,
    render: (v) => <RemainingValue value={v} />,
  },
  {
    title: "สต๊อกขั้นต่ำ",
    dataIndex: "min_stock",
    key: "min_stock",
    align: "right",
    width: 120,
    render: (v) => formatMoney(v, 2),
  },
  {
    title: "ขาดอีก",
    dataIndex: "shortage",
    key: "shortage",
    align: "right",
    width: 120,
    render: (v) => formatMoney(v, 2),
  },
  {
    title: "PO ค้างรับ",
    dataIndex: "pending_po_qty",
    key: "pending_po_qty",
    align: "right",
    width: 120,
    render: (v) =>
      Number(v || 0) > 0 ? (
        <Typography.Text type="warning">{formatMoney(v, 2)}</Typography.Text>
      ) : (
        formatMoney(v, 2)
      ),
  },
  {
    title: "ต้องสั่งเพิ่ม (สุทธิ)",
    dataIndex: "net_required",
    key: "net_required",
    align: "right",
    width: 150,
    sorter: (a, b) => Number(a.net_required || 0) - Number(b.net_required || 0),
    render: (v) => <ShortageValue value={v} />,
  },
  {
    title: "หน่วย",
    dataIndex: "unit",
    key: "unit",
    align: "center",
    width: 100,
    render: (v) =>
      v ? v : <Typography.Text type="secondary">-</Typography.Text>,
  },
];
